import { render, staticRenderFns } from "./create_work_item_cancel_confirmation_modal.vue?vue&type=template&id=45d5bb84"
import script from "./create_work_item_cancel_confirmation_modal.vue?vue&type=script&lang=js"
export * from "./create_work_item_cancel_confirmation_modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports